import { ExtraProps } from 'react-markdown';

type ImgProps = {
  src: string;
  alt: string;
};

function isImgPropsPresent(element: unknown): element is { properties: ImgProps } {
  return (
    element !== null &&
    typeof element === 'object' &&
    'properties' in element &&
    typeof element.properties === 'object' &&
    element.properties !== null &&
    'src' in element.properties &&
    'alt' in element.properties
  );
}

export function PropertyList(props: ExtraProps) {
  return <ul className="list-none py-3 space-y-2" {...props} />;
}

export function MyListItem(props: ExtraProps) {
  return <li className="list-none" {...props} />;
}

export function MarkdownLink(props: ExtraProps) {
  const node = props.node;
  const firstChild = node?.children[0];
  if (!node?.children || node?.children.length === 0 || !firstChild) {
    return null;
  }
  const isImg = isImgPropsPresent(firstChild);
  if (!isImg) return <a target="_blank" rel="noopener noreferrer" className="text-blue-500" {...props} />;
  return (
    <a target="_blank" rel="noopener noreferrer" className="text-blue-500" {...node?.properties}>
      <div className="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
        <img className="rounded-t-lg" src={firstChild.properties.src} alt={firstChild.properties.alt} height={16} />
        <h5 className="p-2 tracking-tight text-gray-900 dark:text-white">{firstChild.properties.alt}</h5>
      </div>
    </a>
  );
}
